module.exports = __webpack_public_path__ + "files/297503ad160b1708cf1bd8fb2317c93a.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bolditalic-webfont.woff2
// module id = 900
// module chunks = 60